import { render, staticRenderFns } from "./personalRules.vue?vue&type=template&id=84500510&scoped=true&"
import script from "./personalRules.vue?vue&type=script&lang=js&"
export * from "./personalRules.vue?vue&type=script&lang=js&"
import style0 from "./personalRules.vue?vue&type=style&index=0&id=84500510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84500510",
  null
  
)

export default component.exports